import { render } from "./IconFontawesome5.vue?vue&type=template&id=5a2360e7"
import script from "./IconFontawesome5.vue?vue&type=script&lang=js"
export * from "./IconFontawesome5.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/d/git/workshop/social-friendsquads/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__